import get from 'lodash-es/get';

import messages from './locales/en-US';

export let locale = 'en-US';
let i18nHandler;

/**
 * Replaces params in a translation message with respective values
 * @param {string} path Translation path (foo.bar.baz)
 * @param {object} params Any params used in the translation message
 * @returns {string}
 */
export function format(path, params) {
  const pathParams = path.match(/({)([\w]+)(})/g) || [];
  let message = path;

  pathParams.forEach((param) => {
    const prop = param.replace(/[{}]/g, '');

    message = message.replace(param, params[prop] || '');
  });

  return message;
}

/**
 * Returns a translation based on translation path
 * @param {string} path Translation path (foo.bar.baz)
 * @param {object} params Any params used in the translation message
 */
function translate(path, params) {
  // Lookup translation
  const value = get(messages, path);

  // Return translation, otherwise the path
  return value ? format(value, params) : path;
}

/**
 * Calls the provided translation method `config.i18n.t` if provided, or the built-in
 * @param {...(string|object)} args
 * @param {string} path Translation path (foo.bar.baz)
 * @param {object} params Any params used in the translation message
 * @returns {string} Translation message
 */
export function t(...args) {
  const value = i18nHandler && i18nHandler(...args);

  // If value exists, but translation doesn't (returns translation key format (xx.xx)),
  // then fallback to default
  if (value && !/^\w{2,}\.\w{2,}/.test(value)) {
    return value;
  }

  // @ts-expect-error - todo: Fix "A spread argument must either have a tuple type or be passed to a rest parameter.ts(2556)"
  // Default English message
  return translate(...args);
}

/**
 * Sets the locale
 * @param {string} l locale
 */
export function use(l) {
  locale = l || locale;
}

/**
 * Sets the translate function `t()`
 * @param {function} fn Translate function `t()`
 */
export function i18n(fn) {
  i18nHandler = fn;
}

export default { i18n, locale, t, use };
